import React from 'react'

const CouponBackgroundSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="403"
    height="404"
    viewBox="0 0 403 404"
    fill="none"
    style={{ width: '100%', height: '100%' }}
  >
    <rect width="402.665" height="403.768" rx="11.0319" transform="matrix(-1 0 0 1 402.665 0)" fill="#0559D2" />
    <rect
      width="402.665"
      height="403.768"
      rx="11.0319"
      transform="matrix(-1 0 0 1 402.665 0)"
      fill="url(#pattern0_6131_17834)"
    />
    <rect
      width="402.665"
      height="403.768"
      rx="11.0319"
      transform="matrix(-1 0 0 1 402.665 0)"
      fill="url(#paint0_linear_6131_17834)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6131_17834"
        x1="402.665"
        y1="-1.90155e-05"
        x2="-79.4074"
        y2="152.114"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.216948" stopColor="#0559D2" />
        <stop offset="1" stopColor="#0559D2" stopOpacity="0" />
      </linearGradient>
      <pattern
        id="pattern0_6131_17834"
        patternUnits="userSpaceOnUse"
        patternTransform="matrix(20.7453 0 0 20.7453 381.92 0)"
        preserveAspectRatio="none"
        viewBox="0 0 64 64"
        width="1"
        height="1"
      >
        <g id="pattern0_6131_17834_inner">
          <g clipPath="url(#clip0_6131_17834)">
            <mask
              id="mask0_6131_17834"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="64"
              height="64"
            >
              <path d="M64 0H0V64H64V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_6131_17834)">
              <path
                d="M0 68C2.20914 68 4 66.2091 4 64C4 61.7909 2.20914 60 0 60C-2.20914 60 -4 61.7909 -4 64C-4 66.2091 -2.20914 68 0 68Z"
                fill="#2377FD"
              />
              <path
                d="M64 68C66.2091 68 68 66.2091 68 64C68 61.7909 66.2091 60 64 60C61.7909 60 60 61.7909 60 64C60 66.2091 61.7909 68 64 68Z"
                fill="#2377FD"
              />
              <path
                d="M0 4C2.20914 4 4 2.20914 4 0C4 -2.20914 2.20914 -4 0 -4C-2.20914 -4 -4 -2.20914 -4 0C-4 2.20914 -2.20914 4 0 4Z"
                fill="#2377FD"
              />
              <path
                d="M64 4C66.2091 4 68 2.20914 68 0C68 -2.20914 66.2091 -4 64 -4C61.7909 -4 60 -2.20914 60 0C60 2.20914 61.7909 4 64 4Z"
                fill="#2377FD"
              />
              <path d="M0 64H64" stroke="#2377FD" />
              <path d="M0 0H64" stroke="#2377FD" />
              <path d="M0 0V64" stroke="#2377FD" />
              <path d="M64 0V64" stroke="#2377FD" />
            </g>
          </g>
        </g>
      </pattern>
      <clipPath id="clip0_6131_17834">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default CouponBackgroundSVG
